import { Type } from '@sinclair/typebox';
import { TradeLimitOrderSchema } from './limit-order.js';
import { TradeSwapSchema } from './swap.js';
export const UnionOrderSchema = Type.Union([
    TradeLimitOrderSchema,
    TradeSwapSchema,
]);
//# sourceMappingURL=union-order.js.map